var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-switcher"},[_c('label',{staticClass:"custom-switcher__label"},[_c('input',{staticClass:"custom-switcher__checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":(e) => _vm.$emit('onChange', e.target.checked)}}),_c('span',{staticClass:"custom-switcher__text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }